import { render, staticRenderFns } from "./EditMailboxUserDialog.vue?vue&type=template&id=83917f02&"
import script from "./EditMailboxUserDialog.vue?vue&type=script&lang=ts&"
export * from "./EditMailboxUserDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports